<template>
  <div class="precautions">
    <div class="precautions_inner bg-white p-6">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="max-w-3xl leading-loose p-3">
          <p  class="text-lg font-black text-left" v-html="displayDescription"></p>
        </div>
      </div>

      <TestingTools_speaking :questionData="questionData" v-if="$route.params.practice_type === 'speaking'" />
      <TestingTools_writing :questionData="questionData" v-if="$route.params.practice_type === 'writing'" />
    </div>
  </div>
</template>

<script>
  import TestingTools_speaking from '@/components/AiHelper/GEPT/TestingTools_speaking'
  import TestingTools_writing from '@/components/AiHelper/GEPT/TestingTools_writing'

  const GEPT_PRECAUTION_DESCRIPTIONS = {
    '初級': {
      '單句寫作': [
        '本測驗包含兩部分：單句寫作、段落寫作。其中，單句寫作又分為「句子改寫、句子合併、句子重組」三個大題。',
        '測驗時間為40分鐘。請點選下方「START」開始進行測驗。'
      ],
      '段落寫作': [
        '本測驗包含兩部分：單句寫作、段落寫作。其中，段落寫作是根據題目說明以及提供的三格圖片寫一篇約50字的短文。',
        '測驗時間為40分鐘。請點選下方「START」開始進行測驗。'
      ],
      '複誦': [
        '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第一部分複誦共五題，題目由耳機播出，每題播出兩次，兩次之間大約有一至兩秒的間隔。聽完兩次後，請馬上複誦一次。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ],
      '朗讀句子與短文': [
        '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第二部分朗讀句子與短文共有五個句子及一篇短文，請利用一分鐘的時間閱讀題目的句子與短文，然後在一分鐘內以正常的速度，清楚、正確地朗讀一遍，閱讀時請不要發出聲音。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ],
      '回答問題': [
        '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第三部分回答問題共七題。題目由耳機播出，每題播出兩次，兩次之間大約有一至兩秒的間隔。聽完兩次後，請馬上回答；每題回答時間為15秒。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ]
    },
    '中級': {
      '中譯英': [
        '本測驗共有兩部分。第一部分為「中譯英」，第二部分為「英文作文」。',
        '測驗時間為40分鐘。請點選下方「START」開始進行測驗。'
      ],
      '英文作文': [
        '本測驗共有兩部分。第一部分為「中譯英」，第二部分為「英文作文」。',
        '測驗時間為40分鐘。請點選下方「START」開始進行測驗。'
      ],
      '朗讀短文': [
        '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第一部分朗讀短文，請先利用一分鐘的時間閱讀題目短文，然後在兩分鐘內以正常的速度，清楚、正確地讀出題目短文，閱讀時請不要發出聲音。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ],
      '回答問題': [
        '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第二部分回答問題共十題。題目已事先錄音，每題經由耳機播出兩次。第一至五題，每題回答時間15秒；第六至十題，每題回答時間30秒。每題播出後，請立即回答。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ],
      '看圖敘述': [
        '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第三部分看圖敘述，題目包含一張圖片及四個相關的問題，請在一分半鐘內完成作答。',
        '測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
      ]
    }
  }

  export default {
    // 注意事項
    name: 'Precautions',

    data () {
      return {}
    },
    props: {
      title: {
        type: String
      },
      level: {
        type: String
      },
      unit: {
        type: String
      },
      questionData: {
        type: Object
      }
    },

    computed: {
      displayDescription () {
        const levelMap = GEPT_PRECAUTION_DESCRIPTIONS[this.level] || {}
        const description = levelMap[this.unit] || levelMap[this.title]

        return description ? description.join('<br/>') : ''
      }
    },

    components: {
      TestingTools_speaking,
      TestingTools_writing
    }
  }
</script>

<style lang="scss" scoped>
.precautions {
  .precautions_inner {
    min-height: calc(60vh);
  }
}
</style>
